import { __assign, __read, __rest } from "tslib";
import React, { useContext, useRef } from "react";
import classNames from "classnames";
import { View, Swiper as TaroSwiper, SwiperItem as TaroSwiperItem, } from "../_core/components";
import { Swiper as CoreSwiper, SwiperItem as CoreSwiperItem, } from "../_core/components/swiper";
import { noop } from "../_util/noop";
import { isChildOfType } from "../_util/is-child-of-type";
import { TaroEnv } from "../_util/env";
import { useDefault } from "../_util/use-default";
import { injectValue } from "../_util/inject-value";
import { SwiperContext } from "./SwiperContext";
import { useConfig } from "../_util/use-config";
var TSwiper = TaroEnv === "weapp" ? TaroSwiper : CoreSwiper;
var TSwiperItem = TaroEnv === "weapp" ? TaroSwiperItem : CoreSwiperItem;
export function Swiper(_a) {
    var indicatorDots = _a.indicatorDots, _b = _a.indicatorActiveColor, indicatorActiveColor = _b === void 0 ? "#ffffff" : _b, _c = _a.indicatorColor, indicatorColor = _c === void 0 ? "rgba(0, 0, 0, .4)" : _c, indicator = _a.indicator, _d = _a.previousMargin, previousMargin = _d === void 0 ? 0 : _d, _e = _a.nextMargin, nextMargin = _e === void 0 ? 0 : _e, _f = _a.displayMultipleItems, displayMultipleItems = _f === void 0 ? 1 : _f, circular = _a.circular, className = _a.className, style = _a.style, _current = _a.current, _g = _a.onChange, _onChange = _g === void 0 ? noop : _g, _h = _a.onAnimationFinish, onAnimationFinish = _h === void 0 ? noop : _h, _j = _a.onClick, onClick = _j === void 0 ? noop : _j, _k = _a.spaceBetween, spaceBetween = _k === void 0 ? 0 : _k, zoom = _a.zoom, animationOnSetCurrent = _a.animationOnSetCurrent, children = _a.children, swiperRef = _a.swiperRef, props = __rest(_a, ["indicatorDots", "indicatorActiveColor", "indicatorColor", "indicator", "previousMargin", "nextMargin", "displayMultipleItems", "circular", "className", "style", "current", "onChange", "onAnimationFinish", "onClick", "spaceBetween", "zoom", "animationOnSetCurrent", "children", "swiperRef"]);
    var classPrefix = useConfig().classPrefix;
    var _l = __read(useDefault(_current, 0, _onChange), 2), current = _l[0], onChange = _l[1];
    var count = React.Children.count(children);
    if (count < 2) {
        // eslint-disable-next-line no-param-reassign
        circular = false;
    }
    var clickHandlersRef = useRef([]);
    var h5Props = {
        zoom: zoom,
        spaceBetween: spaceBetween,
        animationOnSetCurrent: animationOnSetCurrent,
        swiperRef: swiperRef,
        // H5 环境触发
        onSwiperClick: function (index, _a) {
            var event = _a.event;
            var length = count;
            var extra = circular ? displayMultipleItems : 0;
            var current = (index - extra) % length;
            onClick(current, { event: event });
            if (typeof clickHandlersRef.current[current] === "function") {
                clickHandlersRef.current[current](event);
            }
        },
    };
    return (React.createElement(View, { className: classNames(classPrefix + "-swiper", className, {
            "swiper-zoom": zoom,
        }), style: style },
        React.createElement(SwiperContext.Provider, { value: { zoom: zoom } },
            React.createElement(TSwiper, __assign({}, h5Props, { 
                // Taro 环境触发（H5 内部组件已忽略 onClick）
                onClick: function (event) {
                    onClick(current, { event: event });
                    // Taro h5 下 SwiperItem 直接绑定 onClick 会导致 circular 下相邻页点击无效
                    if (TaroEnv !== "weapp" &&
                        typeof clickHandlersRef.current[current] === "function") {
                        clickHandlersRef.current[current](event);
                    }
                }, current: current, circular: circular, indicatorDots: !indicator && indicatorDots, indicatorActiveColor: indicatorActiveColor, indicatorColor: indicatorColor, displayMultipleItems: displayMultipleItems, onChange: function (event) { return onChange(event.detail.current, { event: event }); }, onAnimationFinish: function (event) {
                    return onAnimationFinish(event.detail.current, { event: event });
                }, previousMargin: typeof previousMargin === "number"
                    ? previousMargin + "px"
                    : previousMargin, nextMargin: typeof nextMargin === "number" ? nextMargin + "px" : nextMargin }, props), React.Children.map(children, function (child, index) {
                if (isChildOfType(child, SwiperItem)) {
                    if (child.props.onClick) {
                        clickHandlersRef.current[index] = child.props.onClick;
                    }
                }
                return child;
            })),
            !!indicator && injectValue(indicator)(current, count))));
}
Swiper.displayName = "Swiper";
Swiper.Item = SwiperItem;
export function SwiperItem(_a) {
    var _b = _a.onClick, onClick = _b === void 0 ? noop : _b, children = _a.children, props = __rest(_a, ["onClick", "children"]);
    var zoom = useContext(SwiperContext).zoom;
    if (TaroEnv === "weapp") {
        return (React.createElement(TaroSwiperItem, __assign({ onClick: onClick }, props), children));
    }
    if (zoom) {
        return (React.createElement(TSwiperItem, __assign({}, props),
            React.createElement(View, { className: "swiper-zoom-container" }, children)));
    }
    return React.createElement(TSwiperItem, __assign({}, props), children);
}
SwiperItem.displayName = "SwiperItem";
//# sourceMappingURL=Swiper.js.map